/**
 * Constants for the user_files feature (folder management)
 */

import { kUserFilesFolderListMaxLimit, kUserFilesFolderNameMaxLength } from '@/user_files/limits'

/**
 * API base path for folder operations
 */
export const kUserFilesFoldersApiBasePath = '/api/v1/user-files/folders'

/**
 * Cache duration for folder data (5 minutes)
 */
export const kFolderCacheDurationMs = 5 * 60 * 1000

/**
 * Maximum folder name length (matches backend constraint)
 */
export const kMaxFolderNameLength = kUserFilesFolderNameMaxLength

/**
 * Default limit for folder children/files listing endpoints.
 * Backend requires an explicit `limit` query param (1-500).
 */
export const kDefaultFolderListLimit = kUserFilesFolderListMaxLimit
